import type { FunctionComponent } from 'react';

import classNames from 'classnames';

import Ellipsis from '../../../../components/ellipsis/ellipsis';
import UserBubble from '../../../../components/user_bubble/user_bubble';

import styles from './select_persons_option.module.css';

interface OptionInterface {
  label?: string;
  value?: string;
  imageUrl?: string;
  personVersionFaceImageUrl?: string;
}

interface OptionProps {
  option?: OptionInterface;
  creatorAction?: string;
  isCreatorValue?: boolean;
}

const Option: FunctionComponent<OptionProps> = ({
  option = {},
  creatorAction,
  isCreatorValue,
}) =>
  isCreatorValue ? (
    <div className={styles.container}>
      <UserBubble
        src={option?.personVersionFaceImageUrl}
        className={classNames(styles.avatar, styles.new_person_border)}
        size="sm"
        name={option?.label || ''}
      />

      <Ellipsis>
        <span className={styles.creator_action}>{creatorAction}</span>
        <span className={styles.name}>{option.label}</span>
      </Ellipsis>
    </div>
  ) : (
    <div className={styles.container}>
      <UserBubble
        src={option?.imageUrl}
        className={styles.avatar}
        size="sm"
        name={option?.label || ''}
      />

      <Ellipsis componentProps={{ className: styles.name }}>
        {option?.label}
      </Ellipsis>
    </div>
  );

export default Option;
